import axios from "../../config/axiosConfig";

export default {
  get: () => axios.get("/group/get"),
  add: (data) => axios.post("/group/add", data),
  update: (data) => axios.post("/group/update", data),
  remove: (id) => axios.post("/group/remove", id),
};
